import { ofType } from 'redux-observable';

export const handleEpics = (epic, name) => (action$) => epic(action$.pipe(ofType(name)));

export const finalHandleEpics = (epics) => {
  const appEpics = { ...epics };
  Object.keys(epics).forEach((key) => {
    const storeEpics = epics[key];

    // check if it is internal method
    const internal = !key.indexOf('$');

    if (!internal) {
      appEpics[key] = handleEpics(storeEpics, key);
    } else {
      // flush internals out
      delete appEpics[key];
    }
  });

  return appEpics;
};
